if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.checkoutBtn = this.querySelector('[name="custom_checkout"]');
        this.form.querySelector('[name=id]').disabled = false;
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.onSubmitBISForm = this.onSubmitBISForm.bind(this);
        this.handleCheckoutBtn = this.handleCheckoutBtn.bind(this);

        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isQuickview = this.closest('[data-quickview-modal]');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.initSlider();
        if (_theme.isIpad) {
          this.mobileTabsHandle();
        }
        this.initZoom();
        this.initGeneralEvents();
        this.hadleAccordionsFaq();
      }

      connectedCallback() {}

      disconnectedCallback() {
        this.form.removeEventListener('submit', this.onSubmitHandler);
        this.checkoutBtn.removeEventListener('click', this.handleCheckoutBtn);
        if ($('.notify_me_btn.submit_btn').length) {
          $(document).off('click', '.notify_me_btn.submit_btn');
          $('.notify_me_btn.submit_btn').off();
        }

        const qv = this.closest('.quickview-tpl');
        if (!qv) return;
        $(qv).find('[data-zoom]').trigger('zoom.destroy');
      }

      initSlider() {
        // Sliders are now handled by slideshow-container web component
      }

      initZoom() {
        if ($('[data-zoom]').length && window.innerWidth > 1199) {
          $('[data-zoom]').trigger('zoom.destroy');
          $('[data-zoom]').zoom();

          window.onresize = debounce(function (event) {
            $('[data-zoom]').trigger('zoom.destroy');
            if (window.innerWidth > 1199) {
              $('[data-zoom]').zoom();
            }
          }, 500);
        }
      }

      initGeneralEvents() {
        this.form.addEventListener('submit', this.onSubmitHandler);
        this.checkoutBtn.addEventListener('click', this.handleCheckoutBtn);
        if ($('.notify_me_btn.submit_btn').length) {
          $(document).on('click', '.notify_me_btn.submit_btn', () => {
            this.onSubmitBISForm();
          });
        }
      }

      hadleAccordionsFaq() {
        const prodAccordion = document.querySelectorAll('.product-faq .prod-accordion');
        prodAccordion.forEach((accordion) => {
          const question = accordion.querySelector('button.question');
          const answer = accordion.nextElementSibling;
          const icon = accordion.querySelector('.question .icon-dropdown');
          // question.setAttribute('tabindex','0')
          const toggleAccordion = () => {
            if (icon.classList.contains('active')) {
              icon.classList.remove('active');
              answer.style.maxHeight = '0px';
              question.setAttribute('aria-expanded', 'false');
              question.parentElement.nextElementSibling.classList.remove('show');
            } else {
              icon.classList.add('active');
              answer.style.maxHeight = answer.scrollHeight + 'px';
              question.setAttribute('aria-expanded', 'true');
              question.parentElement.nextElementSibling.classList.add('show');
            }
          };

          question.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleAccordion();
          });

          question.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion();
            }
          });
        });
      }

      mobileTabsHandle() {
        const prodTabs = document.querySelector('.prod-tabcordion--tabs');
        const productFaqContainer = document.querySelector('.product-faq');
        if (productFaqContainer.childElementCount <= 0) {
          document.querySelector('#tab3-tab').classList.add('hideprodTab');
        }
        prodTabs.removeAttribute('role');
        _theme.attributeRemover(prodTabs.querySelector('.data-tab'), ['role', 'aria-controls']);
        const toggledDiv = document.querySelectorAll('.mobile-accordion-controller');
        const toggleParentAccordion = function (e) {
          // let element =  e.target
          this.parentElement.classList.toggle('is-active');

          if (this.getAttribute('aria-expanded') == 'false') {
            this.setAttribute('aria-expanded', 'true');
            Array.from(this.parentElement.querySelectorAll('.question')).forEach((el) => {
              el.removeAttribute('tabindex');
            });
          } else {
            this.setAttribute('aria-expanded', 'false');
            Array.from(this.parentElement.querySelectorAll('.question')).forEach((el) => {
              el.setAttribute('tabindex', '-1');
            });
          }
        };
        Array.from(toggledDiv).forEach((tdv) => {
          const toggleController = tdv.parentElement;

          _theme.attributeRemover(toggleController, [
            'role',
            'tabindex',
            'data-title',
            'aria-labelledby',
          ]);
          _theme.attributeSetter(tdv, { 'aria-expanded': 'false', role: 'button', tabindex: '0' });

          tdv.addEventListener('click', toggleParentAccordion);
          tdv.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleParentAccordion.call(this, e);
            }
          });

          toggleController
            .querySelector('.prod-tabcordion--entry-container')
            .setAttribute('tab-index', '-1');
          Array.from(toggleController.querySelectorAll('.question')).forEach((el) => {
            el.setAttribute('tabindex', '-1');
          });
        });
      }

      handleCheckoutBtn(evt) {
        evt.preventDefault();

        // Signal Buy It Now to datalayer so /cart/add is not also tracked as add_to_cart
        window._theme = window._theme || {};
        window._theme.isBuyNowClick = true;

        let gwpAutoEnable = false,
          gwpAutoThreshold = null,
          gwpAutoVid = null;
        if (_theme.gwpConfig.gwp_auto && _theme.gwpConfig.gwp_auto.enable) {
          gwpAutoEnable = true;
          gwpAutoThreshold = Number(_theme.gwpConfig.gwp_auto.threshold);
          gwpAutoVid = _theme.gwpConfig.gwp_auto.vid;
        }

        this.checkoutBtn.setAttribute('aria-disabled', true);
        _theme.toggleLoading(1);
        this.checkoutBtn.classList.add('loading');
        // this.checkoutBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        // Track buy now event for quickview
        if (this.isQuickview) {
          try {
            const variantObj = JSON.parse(this.querySelector('[data-variant-track]').textContent);
            const formData = new FormData(this.form);
            const variantData = variantObj[formData.get('id')];
            if (variantData) _theme.track.trackQuickViewBuyNow(variantData);
          } catch (error) {
            console.log('Error while sending quickview buy now event');
          }
        }

        this.onSubmitHandler(evt, function () {
          if (gwpAutoEnable && gwpAutoThreshold && gwpAutoVid) {
            _theme.toggleLoading(1);
            Shopify.getCart(function (cart) {
              _theme.toggleLoading(1);
              const hasFreeGift = cart.items.some(
                (item) => item?.properties?._proType === 'freeGift'
              );
              const cart_total_amt = cart.total_price / 100;
              if (!hasFreeGift && cart_total_amt >= gwpAutoThreshold) {
                _theme.Helpers.addProductToCart(gwpAutoVid, 1, 'freeGift', checkoutCB);
              } else {
                checkoutCB();
              }
            });
          } else {
            checkoutCB();
          }
        }, true);

        function checkoutCB() {
          _theme.toggleLoading();
          window.location.href = '/checkout';
        }
      }

      onSubmitBISForm() {
        let hasError = false;
        let msg = '';
        const error = document.querySelector('.product_alert_signup_modal .error');
        error.style.display = 'none';
        const productSKU = document.getElementById('txtProductSKU').value;
        // var variantSKU = document.querySelectorAll('.txtVariantSKU');

        const emailInput = document.getElementById('txtEmailAddress');
        let emailAddress = emailInput.value;
        emailAddress = emailAddress ? emailAddress.trim() : emailAddress;
        const alertCode = document.getElementById('hdnAlertCode').value;
        const checkbox = document.querySelector('.product_alert_signup_modal input#alert_check');
        if (emailAddress === '') {
          hasError = true;
          msg = 'Email field is required';
        } else {
          const regex = /^\S+@\S+\.\S+$/;
          if (!regex.test(emailAddress)) {
            hasError = true;
            msg = 'Please enter a valid email address';
          }
        }

        if (!hasError) {
          _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
          _ltk.Alerts.Submit();
          _theme.track.trackData({ event: 'notifyMeFormSubmitted' });
          alert('Thank you! We will notify you when this product becomes available.');
          if (document.querySelector('.product_alert_signup_wrapper'))
            document.querySelector('.product_alert_signup_wrapper').classList.add('hide');
        } else {
          error.innerHTML = '';
          const newSpan = document.createElement('span');
          newSpan.setAttribute('role', 'alert');
          newSpan.textContent = msg;
          error.appendChild(newSpan);
          error.style.display = 'block';
          emailInput.focus();
        }
      }

      onSubmitHandler(evt, callback, isBuyNow = false) {
        evt.preventDefault();
        const self = this;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Normal ATC must not inherit a prior Buy It Now flag
        if (!isBuyNow && window._theme) {
          window._theme.isBuyNowClick = false;
        }

        this.isQuickview = this.closest('[data-quickview-modal]');
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        _theme.toggleLoading(1);
        this.submitButton.classList.add('loading');
        // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', `gwp,minicart${isBuyNow ? ',isBuyNow' : ''}`.trim());
        formData.append('sections_url', window.location.pathname);

        config.body = formData;

        this.updateATCAccessibilityStatus('in-progress');

        if (this.isQuickview && !isBuyNow) {
          try {
            const variantObj = JSON.parse(this.querySelector('[data-variant-track]').textContent);
            const variantData = variantObj[formData.get('id')];
            if (variantData) _theme.track.trackQuickView(variantData);
            if (variantData) _theme.track.trackQuickViewAddToCart(variantData);
          } catch (error) {
            console.log('Error while sending quickview ATC event');
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Check if this is a shopify quantity limit error
              const isQuantityLimitError =
                response.description &&
                response.description.includes('items were added to your cart due to availability');

              if (isQuantityLimitError) {
                // Items were actually added to cart, so update the cart state
                _theme.initListrakCartUpdateEvent();

                // Show error message using consistent notification system
                _theme.Helpers.showNotification(response.description, 3000);

                // Reload page after showing the notification
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              } else {
                // Handle other errors using the same notification system
                _theme.Helpers.showNotification(response.description);
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                _theme.toggleLoading();
                return;
              }
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              _theme.toggleLoading();
              this.updateATCAccessibilityStatus('error', response.description);
              return;
            }

            _theme.initListrakCartUpdateEvent();

            try {
              const _atcHandle = response && response.handle;
              if (_atcHandle) {
                document.dispatchEvent(
                  new CustomEvent('cart:item_added', { detail: { handle: _atcHandle } })
                );
              }
            } catch (e) {
              /* silent — never break the cart flow */
            }

            if (callback && typeof callback === 'function') {
              callback();
            } else {
              this.updateATCAccessibilityStatus('done');
              _theme.MiniCart.lineItemChangeCallBack(response, () => {
                if (this.isQuickview) $('[data-quickview-modal]').fadeOut();
                _theme.toggleLoading();
                _theme.toggleSideCart(
                  1,
                  function () {
                    const quickview = document.querySelector('[data-quickview-modal]');
                    if (quickview && self.isQuickview) {
                      const sourceHandle = quickview.getAttribute('data-source');
                      if (sourceHandle) {
                        const source = document.querySelector(
                          '.product-item[data-product-id="' + sourceHandle + '"] .quickview-button'
                        );
                        source && source.focus();
                      }
                    } else {
                      const atcBtn = document.querySelector(
                        '.product-form__buttons .product-form__submit'
                      );
                      atcBtn && atcBtn.focus();
                    }
                  },
                  true
                );
              });
            }

            this.error = false;
          })
          .catch((e) => {
            _theme.toggleLoading();
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            _theme.toggleLoading();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      updateATCAccessibilityStatus(status, msg) {
        const ariaElem =
          this.querySelector('#pdp-atc-status') || this.querySelector('[data-aria-live]');
        if (!ariaElem || !status) return;
        switch (status) {
          case 'in-progress':
            ariaElem.textContent = 'Adding';
            break;
          case 'done':
            ariaElem.textContent = 'Item added to your cart';
            break;
          case 'error':
            ariaElem.textContent = msg || 'Something went wrong';
            break;
          default:
            ariaElem.textContent = '';
        }
      }
    }
  );
}

window.addEventListener('DOMContentLoaded', (evt) => {
  const headingMob = document.querySelector('.mob-block-meta .prod-desc-heading');
  const headingMobNotes = document.querySelectorAll('.mob-block-meta .noteItemHeading');
  if (headingMob) {
    const div = document.createElement('div');
    div.className = headingMob.className;
    div.innerHTML = headingMob.innerHTML;
    headingMob.parentNode.replaceChild(div, headingMob);
  }
  if (headingMobNotes.length) {
    headingMobNotes.forEach((headingMobNote) => {
      const div = document.createElement('div');
      div.className = headingMobNote.className;
      div.innerHTML = headingMobNote.innerHTML;
      headingMobNote.parentNode.replaceChild(div, headingMobNote);
    });
  }
  if (_theme.isMobile) {
    document.querySelector('.prod-tabcordion--entry').classList.remove('is-active');
    const headingDesk = document.querySelector('.desk-meta-desc .prod-desc-heading');
    const headingMobNotes = document.querySelectorAll('.mob-block-meta .noteItemHeading');
    const headingDeskNotes = document.querySelectorAll('.desk-meta-desc .noteItemHeading');
    const headingMob = document.querySelector('.mob-block-meta .prod-desc-heading');
    if (headingMob) {
      const h2 = document.createElement('h2');
      h2.className = headingMob.className;
      h2.innerHTML = headingMob.innerHTML;
      headingMob.parentNode.replaceChild(h2, headingMob);
    }
    if (headingDesk) {
      const div = document.createElement('div');
      div.className = headingDesk.className;
      div.innerHTML = headingDesk.innerHTML;
      headingDesk.parentNode.replaceChild(div, headingDesk);
    }

    if (headingDeskNotes.length) {
      headingDeskNotes.forEach((headingDeskNote) => {
        const div = document.createElement('div');
        div.className = headingDeskNote.className;
        div.innerHTML = headingDeskNote.innerHTML;
        headingDeskNote.parentNode.replaceChild(div, headingDeskNote);
      });
    }

    if (headingMobNotes.length) {
      headingMobNotes.forEach((headingMobNote) => {
        const h3 = document.createElement('h3');
        h3.className = headingMobNote.className;
        h3.innerHTML = headingMobNote.innerHTML;
        headingMobNote.parentNode.replaceChild(h3, headingMobNote);
      });
    }
  }
  const timer = setInterval(() => {
    const bvEmptyHeadings = document.querySelectorAll('h3.bv-content-title:empty');
    if (bvEmptyHeadings.length === 0) return;
    bvEmptyHeadings.forEach((bvEmptyHeading) => bvEmptyHeading.remove());
    clearInterval(timer);
  }, 1000);

  setTimeout(() => {
    if (timer) clearInterval(timer);
  }, 10000);
});
